// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__lUtas","black":"Button_black__+xjXS","yellow":"Button_yellow__CCMjO"};